'use strict';

var _ = require('lodash');
function ConfigurationEventsService(hep) {
  function save(rows) {
    var payload = _.transform(rows, function (result, item) {
      var newEntity = {
        eventId: item.eventId,
        name: item.eventName,
        type: item.eventType
      };
      result.push(newEntity);
    });
    return hep.addEvents(payload);
  }
  return {
    save: save
  };
}
ConfigurationEventsService.$inject = ['HepService'];
module.exports = ConfigurationEventsService;